import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { confirmPasswordReset } from '../../services/authService';
import './ResetPassword.css';

function ResetPassword() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!token) {
            navigate('/forgot-password', { replace: true });
        }
    }, [token, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (newPassword !== confirmPassword) {
            setError('Hesla se neshodují');
            return;
        }

        setLoading(true);
        try {
            await confirmPasswordReset(token, newPassword);
            setSuccess(true);
            setTimeout(() => navigate('/login'), 3000);
        } catch (err) {
            if (err.message === 'invalid_token') {
                setError('Tento odkaz je neplatný nebo vypršel. Vyžádejte si nový.');
            } else {
                setError(err.message || 'Změna hesla se nezdařila');
            }
        } finally {
            setLoading(false);
        }
    };

    if (!token) return null;

    return (
        <div className="reset-page">
            <form className="reset-form" onSubmit={handleSubmit}>
                <h2>Nové heslo</h2>
                {error && <div className="reset-error">{error}</div>}
                {success ? (
                    <p className="reset-success">
                        Heslo bylo změněno. Přesměrováváme na přihlášení...
                    </p>
                ) : (
                    <>
                        <label htmlFor="newPassword">Nové heslo</label>
                        <input
                            id="newPassword"
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                            autoComplete="new-password"
                        />
                        <label htmlFor="confirmPassword">Potvrdit heslo</label>
                        <input
                            id="confirmPassword"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            autoComplete="new-password"
                        />
                        <button type="submit" disabled={loading}>
                            {loading ? 'Ukládám...' : 'Změnit heslo'}
                        </button>
                    </>
                )}
                <p className="reset-link">
                    <Link to="/login">Zpět na přihlášení</Link>
                </p>
            </form>
        </div>
    );
}

export default ResetPassword;
